import React from 'react';
import { IIconProps } from './utils';

export const Pause = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M9 6V24M21 6V24" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" />
  </svg>
);
